import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import * as studentsService from '../../services/students/studentsService';
import { classifyStudentsError, toUpdateStudentPayload } from '../../services/students/studentsDto';
import { ChevronLeftIcon } from '../common/mdPageIcons';

function normalizePapelesValue(value) {
  return String(value ?? '').trim().toUpperCase() === 'S' ? 'S' : 'N';
}

function formatPapelesCompletos(value) {
  return normalizePapelesValue(value) === 'S' ? 'Sí' : 'No';
}

export class UpdateAlumno extends Component {
  static displayName = UpdateAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: '',
      name: '',
      papelesCompletos: 'N',
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: '',
      details: this.props.match.params.details,
    };
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveStudent();
    } else {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Los campos Documento y Nombre son obligatorios.',
      });
    }
  };

  handleDNIChangeInput = (e) => {
    this.setState({ dni: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleNameChangeInput = (e) => {
    this.setState({ name: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handlePapelesChangeInput = (e) => {
    this.setState({ papelesCompletos: normalizePapelesValue(e.target.value) });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-alumnos" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle del Alumno' : 'Modificar Alumno';
    const { loading } = this.state;

    return (
      <div className="md-page md-update-alumno">
        <Link className="md-page__back-link" to="/md-alumnos">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados del alumno.'
            : 'Actualice los datos del alumno y confirme los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="alumno-dni">
              Documento de Identidad
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="alumno-dni">{this.state.dni}</div>
            ) : (
              <input
                id="alumno-dni"
                className="md-page__field-input"
                name="dni"
                placeholder="Ingrese DNI"
                onChange={this.handleDNIChangeInput}
                disabled={loading}
                value={this.state.dni}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="alumno-nombre">
              Nombre Completo
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="alumno-nombre">{this.state.name}</div>
            ) : (
              <input
                id="alumno-nombre"
                className="md-page__field-input"
                name="name"
                placeholder="Ingrese Nombre Completo"
                onChange={this.handleNameChangeInput}
                disabled={loading}
                value={this.state.name}
                required
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="alumno-papeles">
              Papeles Completos
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly" id="alumno-papeles">
                {formatPapelesCompletos(this.state.papelesCompletos)}
              </div>
            ) : (
              <select
                id="alumno-papeles"
                className="md-page__field-select"
                value={this.state.papelesCompletos}
                onChange={this.handlePapelesChangeInput}
                disabled={loading}
              >
                <option value="S">Sí</option>
                <option value="N">No</option>
              </select>
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  isOkToSave() {
    return this.state.dni.length > 0 && this.state.name.length > 0;
  }

  async populateData() {
    try {
      const returnModel = await studentsService.getStudent(this.state.id);
      this.setState({
        dni: returnModel.alumnoDni,
        name: returnModel.alumnoNombre,
        papelesCompletos: normalizePapelesValue(returnModel.alumnoPapelesCompletos),
        errorMessage: '',
      });
    } catch (error) {
      const outcome = classifyStudentsError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ errorMessage, showErrorMessage: true });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await studentsService.saveStudent(
        toUpdateStudentPayload({
          id: this.state.id,
          name: this.state.name,
          dni: this.state.dni,
          papelesCompletos: this.state.papelesCompletos,
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyStudentsError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      const errorMessage = outcome.message;
      this.setState({ loading: false, success: false, errorMessage, showErrorMessage: true });
    }
  }
}
